import { toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { LayoutType } from '../types/layouts.esm.js';
import { sameOrder } from './same-order.esm.js';

function compareLayouts(a, b) {
  if (a.type !== b.type) {
    switch (a.type) {
      case LayoutType.Default:
        return -1;
      case LayoutType.Custom:
        switch (b.type) {
          case LayoutType.Default:
            return 1;
          default:
            return -1;
        }
      case LayoutType.Predefined:
        switch (b.type) {
          case LayoutType.Default:
          case LayoutType.Custom:
            return 1;
          default:
            return -1;
        }
      default:
        return 1;
    }
  }
  var aLabel = (a.label || '').toLowerCase();
  var bLabel = (b.label || '').toLowerCase();
  if (aLabel < bLabel) {
    return -1;
  }
  if (bLabel < aLabel) {
    return 1;
  }
  return 0;
}
function sortLayouts(layouts) {
  if (!(layouts !== null && layouts !== void 0 && layouts.length)) {
    return layouts;
  }
  var clone = _toConsumableArray(layouts);
  clone.sort(compareLayouts);
  if (sameOrder(clone, layouts)) {
    return layouts;
  }
  return clone;
}

export { sortLayouts };
//# sourceMappingURL=sort-layouts.esm.js.map
